"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function factorConvert(a, initialFactor, targetFactor) {
    return (a * initialFactor) * 1 / targetFactor;
}
exports.factorConvert = factorConvert;
function findConversionFactor(factorsMap, unit) {
    if (factorsMap.hasOwnProperty(unit)) {
        return factorsMap[unit];
    }
    else {
        throw new Error("Unknown unit '" + unit + "'");
    }
}
exports.findConversionFactor = findConversionFactor;
//# sourceMappingURL=factor-convert.js.map